export default class {
  constructor(context) {
    this.context = context;
    this.form = this.context.querySelector('[data-form="form"]');
    this.submit = this.context.querySelector('[data-form="submit"]');
    this.init();
  }

  init() {
    if (!this.form) {
      let element = this.context;

      while (element.parentElement) {
        element = element.parentElement;
        if (element.tagName.toLowerCase() === 'form') {
          this.form = element;
          break;
        }
      }
    }

    if (this.submit) {
      this.submit.addEventListener('click', (event) => this.formSubmit(event));
    }
  }

  async formSubmit(event) {
    event.preventDefault();
    // if there are any validation errors, don't submit the form
    if (document.querySelectorAll('.field-validation-error').length > 0) return;
    // Revert names from umbraco guid's to fieldAlias name, previously we updated on the BE to use fieldAlias
    // names for the id's and names of the inputs, however this broke some of Umbraco Forms out of
    // the box functionality, such as showing conditional fields. We have restored the guid's but
    // upon submit we need to revert them back. The name is stored in the data-field-alias attribute.
    const dateValuesToRemove = [];
    document.querySelectorAll('[data-field-alias]').forEach((element) => {
      const htmlElement = element;
      const elementName = htmlElement.dataset.fieldAlias;
      if (elementName) {
        // data-field-alias can be set directly on an input, but also a container of multiple inputs.
        if (htmlElement.getAttribute('name')) {
          // g-recaptcha-response name should not be changed
          if (htmlElement.getAttribute('name') !== 'g-recaptcha-response') {
            if (htmlElement.classList.contains('datepickerfield')) {
              const hiddenDateInput = document.getElementById(`${htmlElement.id}_1`);
              if (hiddenDateInput) {
                hiddenDateInput.setAttribute('name', elementName);
                // Only the hidden date field should be submitted as it is in the correct format
                dateValuesToRemove.push(htmlElement.getAttribute('name'));
              }
            } else {
              htmlElement.setAttribute('name', elementName);
            }
          }
        } else {
          // search for all in htmlElement that have names that match the umbraco guid
          const elementsWithGuid = htmlElement.querySelectorAll(
            `[name="${htmlElement.dataset.umb}"]`
          );

          // within the element name replace the name with the fieldAlias name
          elementsWithGuid.forEach((el) => {
            const elHtml = el;
            elHtml.setAttribute('name', elementName);
          });
        }
      }
    });

    const form = this.form;
    const formData = new FormData(form);
    const action = form.getAttribute('action');
    const genericErrorMessageContainer = document.getElementById('generic-error-message');

    dateValuesToRemove.forEach((dateToRemove) => {
      formData.delete(dateToRemove);
    });

    try {
      const response = await fetch(action, {
        method: 'POST',
        body: formData,
      });

      if (response.status === 200 && response.url) {
        window.location.href = response.url;
      } else if (response.status === 400) {
        const errors = await response.json();
        Object.keys(errors).forEach((field) => {
          if (field === 'Form') {
            genericErrorMessageContainer.style.display = 'block';
            genericErrorMessageContainer.textContent = errors[field][0];
          } else {
            const input = form.querySelector(`[name="${field}"]`);
            const fieldId = input.id;
            if (input) {
              const errorSpan = document.createElement('span');
              errorSpan.id = `${fieldId}-error`;
              errorSpan.className = 'field-validation-error';
              errorSpan.textContent = errors[field][0];
              const validationMessageSpan = form.querySelector(`[data-valmsg-for="${fieldId}"]`);
              if (validationMessageSpan) {
                validationMessageSpan.classList.remove('field-validation-valid');
                validationMessageSpan.classList.add('field-validation-error');
                validationMessageSpan.innerHTML = '';
                validationMessageSpan.appendChild(errorSpan);
              }
            } else {
              console.error(`Input element for name attr on field ${field} not found`);
            }
          }
        });
      }
    } catch (err) {
      console.error('An error has occurred: ', err);
    }
  }
}
